var resolution = {
	Set : null,
	Switch : null,
	orientation: null,
	current : null,
	first : true
};

$(function() {

	// voor de styleguide
	// TODO: dit kan niet
	// if ( !customData ) {
	// 	var customData = { themePath: '/wp-content/themes/dekom', };
	// }

	// SVG icons
	$('body').icons( {
		svg: customData.themePath + '/img/output/sprite.svg',
		ajax: true,
		ready: function(prop) {}
	} );
	$( 'body' ).icons.init( '.svg-icon' );


	// Image loader
	$( '.init' ).imageLoader( {
		ready: function(prop) {
			//console.log('done!');
		},
		resize: function(prop) {
			//console.log('resize');
		}
	} );

	function smoothPageScroll() {
	  var hh = 0;
	  if ( $( '.js-main-nav' ).length > 0 ) {
	    hh = $( '.js-main-nav' ).outerHeight( true );
	  }
		$( 'a[href*="#"]:not([href="#"])' ).click(function() {
			if ( location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname ) {
		  	var target = $( this.hash );
		  	target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		  	if ( target.length ) {
		    	$( 'html, body' ).animate( {
		      	scrollTop: target.offset().top - hh - 20
		      }, 1000 );
		      return false;
		    }
		  }
		});
	}
	smoothPageScroll();

	// Scroller
	$(window).scroller({
		items : function() {
			if ( Modernizr.mq( '(min-width: 768px)' ) ) {
				scroll.header.init();
			}
			if ( Modernizr.mq( '(min-width: 1024px)' ) ) {
				scroll.filter.init();
			}
		},
		calculation: function(pos) {
			scroll.header.calculation(pos);
			scroll.filter.calculation(pos);
		},
		animation: function(pos) {
			scroll.header.animation(pos);
			scroll.filter.animation(pos);
		},
		resize: function() {
			scroll.header.resize();
			scroll.filter.resize();
		},
	});

	// youtube
	function scaleYoutube() {
		$('.the-content iframe').each(function() {
			var src = $(this).attr('src'),
			re = new RegExp(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/);
			if (src.match(re)) {
				$(this).attr('width', 'auto').attr('height', 'auto');
				var width = $('.the-content').width(),
				height = width / 16 * 9;
				$(this).attr('width', width).attr('height', height);
			}
		});
	}
	scaleYoutube();
	$('body').youtube();

	if ( $('#kom_course_sign_up,#kom_tryout_lesson').length > 0 ) {

		var $form = $('#kom_course_sign_up').length > 0 ? $('#kom_course_sign_up') : $('#kom_tryout_lesson');

		var $form_submitting = false;

		$form.find('input[name="dln-vr2"]').parent().click(function(){
			var $current_value = $(this).find('input').val();
			$form.find('input[name="dln-vr3"]').closest('.checkbox-group').find('.disabled:not(.default)').removeClass('disabled').removeClass('active');
			$form.find('input[name="dln-vr3"]').closest('.checkbox-group').find(':not(.default) input').prop('disabled', false).prop('checked', false);

			$form.find('input[value="' + $current_value + '"]').closest('.checkbox').addClass('disabled').removeClass('active');
			$form.find('input[value="' + $current_value + '"]').closest('.checkbox').find('input').prop('disabled', true);
		});

		$form.submit(function(e){
			e.preventDefault();

			if ( true === $form_submitting ) {
				return false;
			}

			var $form_data = $(this).serialize();
			$form_submitting = true;

			$form.find('.error').removeClass('error');
			$form.find('.error-msg').remove();
			$form.find('.submit-msg').remove();

			$.ajax({
				url: customData.ajaxURL,
				data: $form_data,
				method: 'POST',
				dataType: 'json'
			}).done(function(data) {
				if ( typeof data.success != 'undefined' && data.success == true ) {
					// success
					$form.find('> *:not(.form--info)').hide();
				} else {
					$form_submitting = false;
					if ( typeof grecaptcha != 'undefined' ) {
						grecaptcha.reset(form.recaptcha.$this);
					}
					if ( typeof data.errors != 'undefined' ) {
						for ( var key in data.errors ) {
							var $field = $('input[name="' + data.errors[ key ].field +'"]');
							$field.closest('.field').addClass('error');
							if ( $field.closest('.field').find('.error-msg').length == 0 ) {
								$field.closest('.field').append('<span class="error-msg">' + data.errors[ key ].message + '</span>');
							}
						}
					}
				}
				if ( typeof data.message != 'undefined' ) {
					$form.append('<div class="submit-msg message">' + data.message + '</div>');
				}
			});
		});
	}

	// switch grid / resize functions
	resolution.Switch = function(size) {
		if (resolution.first === true) {
			resolution.first = false;
			defaultResets.init();
			formEl.init();
			filters.init();
			mainNav.init();
			slidedown.init();
			video.init();
			subMenu.init();
			wizard.init();
			search.init();
			if ( Modernizr.mq( '(min-width: 768px)' ) ) {
				slider.init();
			} else {
				filters.openMobileFilter();
			}
		} else {
			if ( Modernizr.mq( '(min-width: 768px)' ) ) {
				slider.init();
			}
			$( '.image.init' ).imageLoader.resize();
			$( 'body' ).icons.init( '.svg-icon' );
		}
	};

	var resizeTimeout;
	$(window).resize(function(){
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function() {
			resolution.Set();

			$(window).scroller.resize();
		}, 100);
	});

	resolution.orientation = function() {};
	window.addEventListener('orientationchange', resolution.orientation);

	resolution.Set();

});

// switch grid / resize functions
resolution.Set = function() {
	var newResolution;
	if (Modernizr.mq('(max-width: 767px)')) {
		newResolution = 'mobile';
	} else if (Modernizr.mq('(max-width: 1340px)')) {
		newResolution = 'tablet';
		if (Modernizr.mq('(max-width: 1023px)')) {
			newResolution += ' portrait';
		} else {
			newResolution += ' landscape';
		}
	} else {
		newResolution = 'desktop';
	}
	if ( _browserCheck.isTablet() || _browserCheck.isMobile() ) {
		newResolution += ' touch-device';
	}
	if (newResolution != resolution.current) {
		var resolutionClasses = ['mobile', 'tablet', 'desktop', 'portrait', 'IE8'];
		$.each(resolutionClasses, function(i, v){
			$('html').removeClass(v);
		});
		resolution.current = newResolution;
		$('html').addClass(resolution.current);
		resolution.Switch(resolution.current);
	}
};
$('#setGrid').ready(function() {
	resolution.Set();
});
